var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusicians(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.143555,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#EAEAEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 9H9C7.9 9 7 9.9 7 11V25C7 26.1 7.9 27 9 27H27C28.1 27 29 26.1 29 25V11C29 9.9 28.1 9 27 9ZM27 25H9V11H27V25ZM14 21C14 19.34 15.34 18 17 18C17.35 18 17.69 18.07 18 18.18V12H23V14H20V21.03C19.98 22.67 18.65 24 17 24C15.34 24 14 22.66 14 21Z",
    fill: "#787878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicians);
export default __webpack_public_path__ + "static/media/musicians.72a2bfd00c850ec35d2a27f1f724b288.svg";
export { ForwardRef as ReactComponent };